import React from 'react';
import { Modal, Portal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'block',
  maxWidth: '65vw',
  maxHeight: '80vh'
};

export default function ImageModal({ open, handleClose, src }) {
  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <div>
          <img src={src} style={{ ...style }}></img>
          <IconButton color="primary" sx={{ position: 'fixed', top: '25px', right: '25px' }} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </Modal>
    </Portal>
  );
};

